import type { PaymentLimits, ApprovalResult, UpdatePaymentLimitsRequest } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, put } from './request';

export const SERVICE_PATH = 'rest/resource/payments/limits';

export async function getPaymentLimits(): Promise<PaymentLimits> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export async function updatePaymentLimits(
    updatePaymentLimitsRequest: UpdatePaymentLimitsRequest,
): Promise<ApprovalResult> {
    return put<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}`, updatePaymentLimitsRequest);
}
